module.exports = "/_next/static/images/Cover-0a6ff5451432ee0c2e610a66ffafe583.png";